"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var prop_types_1 = (0, tslib_1.__importDefault)(require("prop-types"));
var tooltip_1 = (0, tslib_1.__importDefault)(require("../../../../ui-components/tooltip/tooltip"));
var inline_icon_1 = (0, tslib_1.__importDefault)(require("../../../../ui-components/inline-icon/inline-icon"));
var MoreIcon_1 = (0, tslib_1.__importDefault)(require("../../../../../icons/compiled/components/MoreIcon"));
var styles_scss_1 = (0, tslib_1.__importDefault)(require("./styles.scss"));
var withStyles_1 = require("../../../../../common/utils/withStyles");
var More = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(More, _super);
    function More() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    More.prototype.render = function () {
        var _a = this.props, className = _a.className, onClick = _a.onClick, dataHook = _a.dataHook, ariaLabel = _a.ariaLabel, tooltip = _a.tooltip;
        return (react_1.default.createElement(tooltip_1.default, { content: tooltip },
            react_1.default.createElement("button", { "data-hook": dataHook, onClick: onClick, className: "".concat(className, " ").concat(styles_scss_1.default.icon), "aria-label": ariaLabel },
                react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(MoreIcon_1.default, null) }))));
    };
    More = (0, tslib_1.__decorate)([
        (0, withStyles_1.withStyles)(styles_scss_1.default)
    ], More);
    return More;
}(react_1.default.Component));
More.propTypes = {
    className: prop_types_1.default.string,
    tooltip: prop_types_1.default.node,
    dataHook: prop_types_1.default.string,
    onClick: prop_types_1.default.func,
    ariaLabel: prop_types_1.default.string,
};
exports.default = More;
//# sourceMappingURL=more.js.map